<h3>
  {{
    displayTitle(this.day.destination.titles, this.itinerary?.tour?.language)
  }}
</h3>
<div class="mt-3 mb-5 grid grid-cols-1 gap-4">
  <div *ngIf="this.day.featuredDestination.image" class="mb-3">
    <img class="object-cover rounded-2xl h-64 w-full mt-2"
         [src]=this.day.featuredDestination.image
         alt="{{this.day.destination.country}}">
  </div>
  <div class="mb-3">
    <h5>{{ this.day.featuredDestination.keyword }}</h5>
    <div [innerHTML]="this.day.featuredDestination.body"></div>
  </div>
</div>
<h5>{{ 'itineraries.viewContentModal.destination.selectedDays' | transloco }}</h5>
<div class=" grid grid-cols-6 md:grid-cols-12" [ngClass]="!this.itinerary.tour.isDatesOptional ? 'gap-x-28' : 'gap-x-10'">
  <div [ngClass]="!this.itinerary.tour.isDatesOptional ? 'gap-x-0' : 'gap-x-10'" *ngFor="let date of this.selectedDestination; let i = index">
    <div>
      <nz-tag [nzColor]="'purple'">
        {{
          !this.itinerary.tour.isDatesOptional
            ? (date | date : 'dd/MM/yyyy')
            : ('itineraries.viewContentModal.common.dayLabel' | transloco:{ day: date + 1 })
        }}</nz-tag
      >
    </div>
  </div>
</div>
